import PropTypes from 'prop-types';

// TODO: This appears to be redundant and not needed.
//       This whole component could be integrated into the main Card component.
const CardContent = ({ children, ...rest }) => (
  <div className="flex-1 p-4 card-last-margin" {...rest}>
    {children}
  </div>
);

CardContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CardContent;
